function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Common from '@/components/user/accessCommon';
import { userAssessEditApi, userAssessInfo, userAssessCreateApi } from '@/api/user';
import { assessPlanPeriodApi, assessTargetCateListApi, assessTemplatePutApi } from '@/api/enterprise';
export default {
  name: 'GoalSetting',
  components: {
    selectTarget: function selectTarget() {
      return import('@/components/form-common/dialog-target');
    },
    selectTemplate: function selectTemplate() {
      return import('@/components/form-common/dialog-template');
    },
    dateQuarter: function dateQuarter() {
      return import('@/components/form-common/select-dateQuarter');
    }
  },
  props: {
    id: {
      type: Number | String,
      default: 0
    },
    addButton: {
      // 添加模板判断
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: {}
    },
    strType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      tableData: [],
      dialogVisible: false,
      dialogTemplate: false,
      from: {
        name: '',
        ratio: 100
      },
      rowId: 0,
      info: {
        name: '',
        info: '',
        cate_id: ''
      },
      nullList: {
        name: '',
        content: '',
        ratio: ''
      },
      index: '',
      is_draft: 0,
      is_temp: 0,
      type: 1,
      department: [],
      options: [],
      temp: [],
      editDimension: 1,
      editDimensionIndex: -1,
      remindButton: false,
      periodOptions: Common.periodOptions,
      periodOption: [{
        value: '',
        label: this.$t('access.selecteassessmenttype')
      }],
      dateArray: [{
        value: 1,
        type: 'week',
        text: '选择周',
        format: 'yyyy 第 WW 周'
      }, {
        value: 2,
        type: 'month',
        text: '选择月份',
        format: 'yyyy-MM'
      }, {
        value: 4,
        type: ''
      }, {
        value: 5,
        type: ''
      }, {
        value: 3,
        type: 'year',
        text: '选择年份',
        format: 'yyyy'
      }],
      quarterBtn: false,
      halfYearBtn: false,
      tableFrom: {
        period: '',
        time: '',
        date: '',
        testUid: []
      },
      accessInfo: [],
      pickerOptions0: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 86400000;
        },
        firstDayOfWeek: 1
      },
      frameUserArray: [],
      frameUserOption: [],
      assessPlan: [],
      isEdit: false,
      tempButton: 1,
      tempData: {},
      saveLoading: false,
      tempLoading: false,
      userInfo: this.$store.state.user.userInfo,
      enterprise: this.$store.state.user.enterprise
    };
  },
  computed: {
    dimensionMax: function dimensionMax() {
      var max = 100;
      if (this.enterprise.compute_mode) {
        max = this.enterprise.maxScore;
      }
      if (this.tableData && this.tableData.length > 0) {
        this.tableData.forEach(function (value) {
          max -= value.ratio;
        });
      }
      return max;
    },
    text: function text() {
      return function (value) {
        if (!value) {
          return '100%';
        } else {
          return String(value).length * 13 + 10 + 'px';
        }
      };
    }
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    }
  },
  mounted: function mounted() {
    // 获取考核类型
    this.assessPlanPeriod();
    this.rowId = this.rowData.id || this.id;
    this.getTableData();
  },
  methods: {
    setOptions: function setOptions() {
      this.periodOption = [{
        value: '',
        label: this.$t('access.selecteassessmenttype')
      }];
    },
    handleDelete: function handleDelete(index, $index) {
      this.tableData[index].target.splice($index, 1);
      this.handleScore(index);
    },
    addAssess: function addAssess() {
      this.editDimension = 1;
      this.dialogVisible = true;
    },
    getTableData: function getTableData() {
      var _this = this;
      if (this.rowId > 0) {
        userAssessInfo(this.rowId).then(function (res) {
          res.data === undefined ? _this.tableData = [] : _this.tableData = res.data.info;
          res.data === undefined ? _this.accessInfo = [] : _this.accessInfo = res.data.assessInfo;
          if (_this.rowId !== 0) {
            _this.tableFrom.period = _this.accessInfo.period;
            _this.tableFrom.date = _this.accessInfo.time;
            _this.tableFrom.time = _this.accessInfo.time;
            _this.isEdit = true;
            if (_this.strType !== 'copy') {
              _this.frameUserOption = [_this.accessInfo.test];
              _this.tableFrom.testUid = [_this.accessInfo.test.id];
            } else {
              _this.tableFrom.testUid = [];
              _this.tableFrom.period = '';
            }
          }
        });
      }
    },
    assessPlanPeriod: function assessPlanPeriod() {
      var _this2 = this;
      assessPlanPeriodApi().then(function (res) {
        res.data == undefined ? _this2.assessPlan = [] : _this2.assessPlan = res.data;
        if (_this2.assessPlan.length === 0) {
          _this2.$message.error('请开启考核类型');
        } else {
          var _loop = function _loop(i) {
              index = _this2.periodOptions.findIndex(function (item) {
                return item.value === _this2.assessPlan[i].period;
              });
              _this2.periodOption.push(_this2.periodOptions[index]);
            },
            index;
          for (var i = 0; i < _this2.assessPlan.length; i++) {
            _loop(i);
          }
        }
      });
    },
    getTargetCate: function getTargetCate() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                types: _this3.type
              };
              _this3.options = [];
              _context.next = 4;
              return assessTargetCateListApi(data);
            case 4:
              result = _context.sent;
              res.data == undefined ? _this3.department = [] : _this3.department = result.data;
              _this3.department.forEach(function (value) {
                _this3.options.push({
                  value: value.id,
                  label: value.name
                });
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleClose: function handleClose() {
      this.clickCancel();
    },
    addOk: function addOk() {
      if (this.from.name == '') {
        this.$message.error(this.$t('access.placeholder03'));
      } else if (this.from.ratio == '') {
        this.$message.error(this.$t('access.placeholder04'));
      } else {
        if (this.editDimension == 1) {
          this.tableData.push({
            name: this.from.name,
            ratio: !this.enterprise.compute_mode ? this.from.ratio : 0,
            target: []
          });
        } else {
          this.tableData[this.editDimensionIndex].name = this.from.name;
          this.tableData[this.editDimensionIndex].ratio = this.from.ratio;
        }
        this.clickCancel();
      }
    },
    handleScore: function handleScore(index) {
      var _this4 = this;
      if (!this.enterprise.compute_mode) {
        return false;
      } else {
        this.tableData[index].ratio = 0;
        this.tableData[index].target.forEach(function (value) {
          _this4.tableData[index].ratio += value.ratio ? value.ratio : 0;
        });
      }
    },
    setTemplate: function setTemplate() {
      if (this.tempButton === 2) {
        this.info.name = this.tempData.name;
        this.info.info = this.tempData.info;
      }
      this.dialogTemplate = true;
    },
    addTemplate: function addTemplate() {
      this.is_temp = 1;
      var res = this.judge(1);
      if (res.length > 0) {
        this.setTemplate();
      }
    },
    cancelTemplate: function cancelTemplate() {
      this.dialogTemplate = false;
      this.info.name = '';
      this.info.info = '';
      this.info.cate_id = '';
    },
    templateClose: function templateClose() {
      this.cancelTemplate();
    },
    templateOk: function templateOk() {
      if (this.info.name === '') {
        this.$message.error(this.$t('access.placeholder05'));
      } else if (this.info.info === '') {
        this.$message.error(this.$t('access.placeholder06'));
      } else {
        if (this.tempButton === 1) {
          if (this.isEdit) {
            this.preserveTemp();
          } else {
            this.preserve();
          }
        } else {
          this.putTemplate();
        }
      }
    },
    clickCancel: function clickCancel() {
      this.dialogVisible = false;
      this.editDimension = 1;
      this.editDimensionIndex = -1;
      this.from.name = '';
      this.from.ratio = this.dimensionMax;
    },
    addTarget: function addTarget(index) {
      var len = this.tableData[index].target.length - 1;
      if (len < 0) {
        this.tableData[index].target = [{
          name: '',
          content: '',
          ratio: 10
        }];
        this.handleScore(index);
      } else {
        if (this.tableData[index].target[len].name == '') {
          this.$message.error(this.$t('access.placeholder09'));
        } else if (this.tableData[index].target[len].content == '') {
          this.$message.error(this.$t('access.placeholder10'));
        } else if (this.tableData[index].target[len].ratio == '') {
          this.$message.error(this.$t('access.placeholder11'));
        } else {
          this.tableData[index].target.push({
            name: '',
            content: '',
            ratio: 10
          });
          this.handleScore(index);
        }
      }
    },
    selectTarget: function selectTarget(index) {
      this.index = index;
      this.$refs.selectTarget.openDialog();
    },
    selectTemplate: function selectTemplate() {
      this.tableData && this.tableData.length > 0 ? this.remindButton = true : this.remindButton = false;
      this.$refs.selectTemplate.openDialog();
    },
    dialogChangeDada: function dialogChangeDada(data) {
      var _this5 = this;
      data.forEach(function (res) {
        _this5.tableData[_this5.index].target.push({
          name: res.name,
          content: res.content,
          info: res.info,
          ratio: ''
        });
      });
    },
    deleteTargetList: function deleteTargetList(index) {
      this.tableData.splice(index, 1);
    },
    addTemp: function addTemp() {
      this.is_temp = 1;
      var res = this.judge();
      if (res.length > 0) {
        this.setTemplate();
      }
    },
    addPreserve: function addPreserve(type, status) {
      this.is_draft = 1;
      this.is_temp = 0;
      if (this.tempButton !== 1) {
        this.putTemplate();
      } else {
        this.preserve();
      }
    },
    editPreserve: function editPreserve(type, status) {
      var _this6 = this;
      if (type === 1) {
        this.is_draft = 0;
        this.$modalSure('你确定要提交考核吗').then(function () {
          _this6.preserveTemp(status);
        });
      } else {
        this.is_draft = 1;
        this.preserveTemp();
      }
    },
    // 添加保存绩效
    preserve: function preserve(status) {
      var _this7 = this;
      if (this.handleTotalWeight() != this.enterprise.maxScore) {
        this.$message.error('当前总分和总分不一致');
        return false;
      }
      var res = this.judge();
      if (res.length > 0) {
        var data = {
          is_submit: 0,
          is_draft: status == 'only' ? 1 : this.is_draft,
          is_temp: this.is_temp,
          period: this.tableFrom.period,
          name: this.info.name,
          info: this.info.info,
          time: this.tableFrom.date,
          test_uid: this.tableFrom.testUid,
          types: this.enterprise.compute_mode,
          data: res
        };
        this.is_temp === 0 ? this.saveLoading = true : this.tempLoading = true;
        if (this.rowId > 0 && this.strType != 'copy' && this.tempButton !== 2) {
          userAssessEditApi(this.rowId, data).then(function (res) {
            if (res.status == 200) {
              _this7.is_temp === 0 ? _this7.saveLoading = false : _this7.tempLoading = false;
              if (_this7.is_temp !== 1) {
                _this7.clickReturn();
              }
              _this7.is_draft = 0;
              _this7.is_temp = 0;
              _this7.cancelTemplate();
            } else {
              _this7.saveLoading = false;
            }
          }).catch(function (error) {
            _this7.is_temp === 0 ? _this7.saveLoading = false : _this7.tempLoading = false;
          });
        } else {
          userAssessCreateApi(data).then(function (res) {
            if (res.status == 200) {
              _this7.is_temp === 0 ? _this7.saveLoading = false : _this7.tempLoading = false;
              if (_this7.is_temp !== 1) {
                _this7.clickReturn();
              }
              _this7.is_draft = 0;
              _this7.is_temp = 0;
              _this7.cancelTemplate();
            } else {
              _this7.saveLoading = false;
            }
          }).catch(function (error) {
            _this7.is_temp === 0 ? _this7.saveLoading = false : _this7.tempLoading = false;
          });
        }
      }
    },
    // 保存
    preserveTemp: function preserveTemp(status) {
      var _this8 = this;
      var res = this.judge();
      if (res.length > 0) {
        var data = {
          is_temp: this.is_temp,
          is_draft: status == 'only' ? 1 : this.is_draft,
          name: this.info.name,
          info: this.info.info,
          types: this.enterprise.compute_mode,
          data: res
        };
        this.saveLoading = true;
        userAssessCreateApi(data).then(function (res) {
          _this8.saveLoading = false;
          if (_this8.is_temp !== 1) {
            _this8.clickReturn();
          }
          _this8.is_temp = 0;
          _this8.cancelTemplate();
        }).catch(function (error) {
          _this8.saveLoading = false;
        });
      }
    },
    putTemplate: function putTemplate() {
      var _this9 = this;
      var res = this.judge(2);
      if (res.length > 0) {
        var data = {
          is_temp: 1,
          is_draft: this.is_draft,
          name: this.tempData.name,
          info: this.tempData.info,
          types: this.enterprise.compute_mode,
          data: res,
          cate_id: this.tempData.cate_id
        };
        this.tempLoading = true;
        assessTemplatePutApi(this.tempData.id, data).then(function (res) {
          _this9.tempLoading = false;
          if (_this9.is_draft === 0 || _this9.is_temp !== 1) {
            _this9.clickReturn();
          }
          _this9.is_temp = 0;
          _this9.cancelTemplate();
        }).catch(function (error) {
          _this9.tempLoading = false;
        });
      }
    },
    clickReturn: function clickReturn() {
      this.$emit('handleGoal');
    },
    judge: function judge(type) {
      var res = [];
      if (type !== 2) {
        if (this.tableData.length <= 0) {
          this.$message.error(this.$t('access.placeholder12'));
        } else if (this.dimensionMax > 0 && this.is_draft === 0 && this.is_temp === 0) {
          this.$message.error(this.$t('access.placeholder13'));
        } else if (this.tableFrom.period === '' && this.is_temp === 0) {
          this.$message.error(this.$t('access.placeholder14'));
        } else if (this.tableFrom.date === '' && !this.isEdit && this.is_temp === 0) {
          this.$message.error(this.$t('access.placeholder15'));
        } else if (this.tableFrom.testUid.length === 0 && this.is_temp === 0) {
          this.$message.error('被考核人不能为空');
        }
      }
      if (this.tableData.length > 0) {
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].name == '') {
            this.$message.error('考核维度名称不能为空');
            break;
          }
          if (this.tableData[i].ratio <= 0 && this.is_draft === 0) {
            this.$message.error('考核维度权重不能为零');
            break;
          }
          if (this.tableData[i].target.length <= 0) {
            this.$message.error('考核指标不能空');
            break;
          }
          var target = [];
          for (var j = 0; j < this.tableData[i].target.length; j++) {
            if (this.tableData[i].target[j].name == '') {
              this.$message.error('指标名称不能为空');
              break;
            }
            if (this.tableData[i].target[j].content == '') {
              this.$message.error('指标内容不能为空');
              break;
            }
            if (this.tableData[i].target[j].info == '') {
              this.$message.error('评分标准不能为空');
              break;
            }
            if (this.tableData[i].target[j].ratio <= 0 && this.is_draft === 0) {
              this.$message.error('指标权重不能为零');
              break;
            }
            target.push({
              name: this.tableData[i].target[j].name,
              content: this.tableData[i].target[j].content,
              info: this.tableData[i].target[j].info,
              ratio: this.tableData[i].target[j].ratio,
              id: this.tableData[i].target[j].id || 0
            });
          }
          if (target.length <= 0) {
            break;
          }
          res.push({
            name: this.tableData[i].name,
            ratio: this.tableData[i].ratio,
            id: this.tableData[i].id,
            target: target
          });
          if (res[i].target.length !== this.tableData[i].target.length) {
            res = [];
          }
        }
      }
      if (res.length > 0) {
        return res;
      } else {
        return [];
      }
    },
    // 选用考核模板回调
    templateChange: function templateChange(data) {
      var _this10 = this;
      // 加分评分判断
      var maxVal = 0;
      if (data.data.length > 0) {
        data.data.map(function (item) {
          item.target.map(function (item2) {
            maxVal += item2.ratio;
          });
        });
      }
      if (this.enterprise.compute_mode && this.enterprise.maxScore !== maxVal && data.data.length > 0) {
        var sumRatio = 0;
        data.data.forEach(function (value) {
          value.ratio = Math.round(value.ratio * _this10.enterprise.maxScore / 100);
        });
        data.data.slice(0, data.data.length - 1).map(function (item) {
          sumRatio += item.ratio;
        });
        if (data.data[data.data.length - 1]) {
          data.data[data.data.length - 1].ratio = this.enterprise.maxScore - sumRatio;
        }
        data.data.map(function (per) {
          per.target.forEach(function (val) {
            val.ratio = Math.round(per.ratio * val.ratio / 100);
          });
          var sum = 0;
          per.target.slice(0, per.target.length - 1).map(function (item) {
            sum += item.ratio;
          });
          per.target[per.target.length - 1].ratio = per.ratio - sum;
        });
      }
      if (data.edit === 1) {
        this.tempButton = 1;
        this.tableData = data.data;
      } else {
        this.tempButton = 2;
        this.tempData = data.data.temp;
        this.tableData = data.data.info;
      }
    },
    editRatioName: function editRatioName(index) {
      this.editDimension = 2;
      this.editDimensionIndex = index;
      this.from.name = this.tableData[index].name;
      this.from.ratio = this.tableData[index].ratio;
      this.dialogVisible = true;
    },
    changePeriod: function changePeriod(e) {
      var _this11 = this;
      if (e == 1) {
        var selectedWeek = this.$moment(new Date()).isoWeek();
        var selectedWeekFirst = this.$moment().isoWeek(selectedWeek).weekday(1).format('YYYY/MM/DD');
        this.pickerOptions0 = {
          disabledDate: function disabledDate(time) {
            return time.getTime() < new Date(selectedWeekFirst);
          },
          firstDayOfWeek: 1
        };
      } else {
        this.pickerOptions0 = {
          disabledDate: function disabledDate(time) {
            return time.getTime() < Date.now() - 86400000;
          },
          firstDayOfWeek: 1
        };
      }
      // 切换季度半年考核
      this.tableFrom.date = '';
      if (e == 4) {
        this.quarterBtn = true;
        this.halfYearBtn = true;
        this.$nextTick(function () {
          _this11.$refs.dateQuarter.showValue = '';
        });
      } else if (e == 5) {
        this.quarterBtn = true;
        this.halfYearBtn = false;
        this.$nextTick(function () {
          _this11.$refs.dateQuarter.showValue = '';
        });
      } else {
        this.quarterBtn = false;
      }
      // 切换选择被考核人
      var index = this.assessPlan.findIndex(function (item) {
        return item.period === e;
      });
      this.tableFrom.testUid = [];
      this.frameUserOption = this.assessPlan[index].test;
    },
    getDateValue: function getDateValue() {
      if (this.tableFrom.period == 1) {
        this.tableFrom.date = this.$moment(this.tableFrom.time).format('YYYY-WW');
      } else if (this.tableFrom.period == 2) {
        this.tableFrom.date = this.$moment(this.tableFrom.time).format('YYYY-MM');
      } else if (this.tableFrom.period == 3) {
        this.tableFrom.date = this.$moment(this.tableFrom.time).format('YYYY');
      }
    },
    getQuarterDate: function getQuarterDate(data) {
      this.tableFrom.date = data;
    },
    // 当前每一项得分计算
    handleWeight: function handleWeight(target) {
      var max = 0;
      if (target.length > 0) {
        target.forEach(function (value) {
          max += value.ratio;
        });
        return max;
      } else {
        return 0;
      }
    },
    // 当前总得分
    handleTotalWeight: function handleTotalWeight() {
      var max = 0;
      if (this.tableData && this.tableData.length > 0) {
        this.tableData.forEach(function (value) {
          max += value.ratio;
        });
        return max;
      } else {
        return 0;
      }
    }
  }
};